<template>
  <div id="MsgHistory" class="base_block" ref="MsgHistory">
    <div
      class="message_block"
      v-for="message in messages"
      :key="message.timestamp"
      :class="message.from">
            <span class="from">
            <AvatarIcon
              :name="message.name"
              :image_url="bot.image_url"
              type="bot"
            >
            </AvatarIcon>
            </span>
      <span v-if="message.msgText" :class="'msgText'  " v-html="message.msgText"></span>
      <span v-if="message.formatted_message" class="msgText" v-html="message.formatted_message"></span>
      <span v-if="message.image">
                <img :src="message.image" class="message_image">
            </span>
      <span v-if="message.video">
               <iframe
                 width="560"
                 height="315"
                 :src="message.video"
                 frameborder="0"
                 allow=" autoplay; encrypted-media"
                 autoplay
                 @ended="video_event"
               ></iframe>
            </span>
      <span v-if="message.video_clip" class="video_clip">
<div v-if="message.video_clip">
  <div class="video-container" @ended="video_ended_event" @pause="video_ended_event">
         <iframe
           :id="message.p_id"
           width="560"
           height="315"
           :src="message.video_clip.url"
           frameborder="0"
           @ended="video_ended_event"
           @pause="video_ended_event"
           allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
           allowfullscreen class="video_player">
         </iframe>
</div>

          <div v-if="message.video_clip && message.video_clip.caption"
               class="video_caption"
               v-html="message.video_clip.caption" >
          </div>
</div>
      </span>
      <span v-if="message.audio_clip" class="audio_clip">
        <div v-if="message.audio_clip.url">
        <audio :src="message.audio_clip.url" controls autoplay onplay="audio_event" onended="audio_event"
               onplaying="audio_event"></audio>
          <div v-if="message.audio_clip.desc" v-html="message.audio_clip.desc"></div>
        </div>
        <div v-else>
          <p><b>AUDIO Payload is missing URL for audio file</b></p>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
    import AvatarIcon from "./AvatarIcon"
    import store from "../store";
    import {EventBus} from "./EventBus";
    console.dir(store);

    export default {
        name: "MsgHistory",
        components: {
            AvatarIcon
        },
        props: ['messages' , 'bot'],
        updated: function () {
            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been re-rendered
                this.watch_vimeo_players();
                console.log("Page was updated");
            })
        },
        methods: {
            video_ended_event(e) {
                alert("Whahoo!  The video done ended");
                console.dir(e);
            },
            audio_event(e) {
                console.log("Audio Event:");
                console.dir(e);
            },
            watch_vimeo_players() {
                let players = document.getElementsByClassName('video_player');
                // Only attach to the last player:
                if (players && players.length) {
                   let iframe_player = players[players.length -1];
                   let Vimeo = window.Vimeo;
                    const player = new Vimeo.Player(iframe_player);
                    const player_id = iframe_player.id;
                    console.log("Attaching events to Player:", player_id);
                  player.on('ended', (e)=>{
                      this.$store.dispatch('recognition_enabled');
                      this.$store.dispatch('listening_on');
                      EventBus.$emit('start_listening', "watch_vimeo_players");
                      EventBus.$emit('media_ended' );
                      console.log("Player ENDED:");
                      console.dir(e);
                      console.log("/Player ENDED");
                  });
                    player.on('play', (e)=>{
                        EventBus.$emit('stop_listening', "watch_vimeo_players");
                        store.dispatch('recognition_off');
                        store.dispatch('listen_off');
                        this.$store.dispatch('recognition_off');
                        this.$store.dispatch('recognition_disabled')
                        console.log("Player PLAYING:");
                        console.dir(e);
                        console.log("/Player PLAYING");
                       // alert("Player Play Event.");
                    });
                    player.on('pause', (e)=>{

                        console.log("Player PAUSED:");
                        console.dir(e);
                        console.log("/Player PAUSED");
                    });
                  /*
                   if (iframe_player && window.Vimeo) {
                       const Vimeo = window.Vimeo;
                       console.log("*************** We have Vimeo Player ****************");
                       const player = new Vimeo.Player(iframe_player);
                       player.on('ended', (e) => {
                           store.dispatch('recognition_on');
                           store.dispatch('video_player_done', e);
                           console.dir(e);
                           console.log("VIDEO ENDED - Allow speech recognition.")
                       });
                       player.on('play', (e) => {
                           store.dispatch('recognition_off');
                           console.dir(e);
                           console.log("VIDEO PLAYING - STOP speech recognition.")
                       });
                   } else {
                       console.log("*************** NO PLAYA! ****************");
                       console.log("No Vimeo object found!")
                       console.log("*************** ****************");
                   }
                   */
                }
                /*
                for (let player of players) {
                    console.log("Player to watch:");
                    const vimeo_player = new Vimeo.Player(player);
                }
                 */
            }
        }
    }

</script>

<style scoped>
  .message_image {
    width: 30rem;
  }

  #MsgHistory {
    display: grid;
    /* display: flex; */
    background-color: white;
    align-items: end;
    align-content: end;
    max-width: 100vw;
    min-width: 80vw;
    margin: auto;

    /*overflow-x: scroll; */
  }

  .message_block {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 0.24rem;
    margin-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;

  }

  .message_block.user {
    grid-template-columns: 1fr auto;
    margin-left: 15%;
  }

  .message_block.bot {
    margin-right: 15%;
  }

  .msgText {
    font-weight: bold;
    border-radius: 1.2rem;
    text-align: justify;
    padding: 1rem;
  }

  a:any-link,
  .message_block a,
  .msgText > a:any-link  {
    color: lime !important;
    background-color: cornflowerblue;
  }
  .message_block.bot .msgText {
    background-color: navy;
    color: white;
    padding-left: 3rem;
    border-radius: 0rem 4rem 4rem 4rem;

  }
/*  Assume all spans inside message blocks are tooltips */
  .message_block.bot .msgText span {
    border-bottom: 1px dotted whitesmoke;
    cursor: help;
  }



  a:link {color: blue;}
  a:visited {color: purple;}
  a:hover {color: red;}
  a:active {color: yellow;}
  a:any-link {color: orange !important;}
 html body a:-webkit-any-link {color: orange !important;}
 html > body a:link {color: orange !important;}
  html  body a:link {color: orange !important;}


  .message_block.user {
    justify-content: end;
    font-weight: bold;
  }

  .message_block.user .from {
    display: none;
    border: none;
  }

  .message_block.user .msgText {
    background-color: gainsboro;
    color: navy;
    font-weight: bold;
    /*border: 3px solid navy; */
    border-radius: 4rem 0 4rem 4rem;
    padding-left: 2rem;
    margin-left: 15%;
  }

  /* Responsive Video Player  */
  Iframe {
    width: 100%;
    height: auto;
  }

  .video-container {
    background-color: navy;
    position: relative;
    padding-bottom: 56.25%;
    /*
    padding-top: 30px;
     */
    height: 0;
    overflow: hidden;
  }

  .video-container iframe,
  .video-container object,
  .video-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

  }

  .video_clip {
    max-width: 100vmin;
    max-height: 100vmin;
  }

  .video_caption {
    color: whitesmoke;
    background-color: navy;
    font-weight: bold;
    padding: 0.5rem;
  }


</style>
<style>
  /* NOTE: This only works if it is NOT in scoped style for some reason. */
  body #MsgHistory a:any-link {
    color: #FFDC3A;
    background-color: black;
    border: 1px solid white;
    padding: 2pt;
  }
  span[title]:hover{
    cursor: help;
  }

</style>
